import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { ViewModelForm } from "gw-portals-viewmodel-react";
import metadata from "./UmbrellaCoverageTable.metadata.json5";
import styles from "./UmbrellaCoverageTable.module.scss";
import "./UmbrellaCoverageTable.messages";

const getCell = (items, index, property) => {
    return !_.isObject(items[property.id]) ? items[property.id] : null;
};

export function UmbrellaCoverageTable({ data }) {
    const overrides = {
        umbrellaCoverageTable: {
            data: data,
        },
        umbrellaUnderlyingPolicyTable: {
            visible: false,
        },
    };

    const resolvers = {
        resolveCallbackMap: {
            getCellCoverage: getCell,
        },
        resolveClassNameMap: styles,
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={data}
            overrideProps={overrides}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

UmbrellaCoverageTable.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({})),
};

UmbrellaCoverageTable.defaultProps = {
    data: [],
};

export function UmbrellaUnderlyingPolicyTable({ data }) {
    const overrides = {
        umbrellaUnderlyingPolicyTable: {
            data: data,
        },
        umbrellaCoverageTable: {
            visible: false,
        },
    };

    const resolvers = {
        resolveCallbackMap: {
            getCellValue: getCell,
        },
        resolveClassNameMap: styles,
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={data}
            overrideProps={overrides}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

UmbrellaUnderlyingPolicyTable.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({})),
};

UmbrellaUnderlyingPolicyTable.defaultProps = {
    data: [],
};
export default { UmbrellaCoverageTable, UmbrellaUnderlyingPolicyTable };
